"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PackageJson_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadPackageJson = exports.getPackageJson = exports.formatPackageName = exports.PackageJson = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
const fs_1 = require("fs");
const path_1 = require("path");
let PackageJson = PackageJson_1 = class PackageJson {
    static formatPackageName(packageName, { scopeRegex = /^@[^/]+\// } = {}) {
        const nameWithoutScope = packageName.replace(scopeRegex, '');
        return nameWithoutScope
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
    static getPackageJson({ maxDepth = 10, startDir = process.cwd() } = {}) {
        let currentDir = startDir;
        let depth = 0;
        const checkedDirs = [];
        while (depth < maxDepth) {
            checkedDirs.push(currentDir);
            const packageJsonPath = (0, path_1.join)(currentDir, 'package.json');
            if ((0, fs_1.existsSync)(packageJsonPath)) {
                return PackageJson_1.loadPackageJson(packageJsonPath);
            }
            const parentDir = (0, path_1.dirname)(currentDir);
            if (parentDir === currentDir) {
                throw new Error(`No package.json found during directory traversal of dirs [${checkedDirs.join(', ')}].`);
            }
            currentDir = parentDir;
            depth++;
        }
        throw new Error(`Reached maximum directory traversal depth without finding a package.json. Checked dirs [${checkedDirs.join(', ')}].`);
    }
    static loadPackageJson(packageJsonPath, options = {}) {
        const { returnUndefinedOnError = false } = options;
        try {
            const packageJsonContent = (0, fs_1.readFileSync)(packageJsonPath, 'utf8');
            const packageJson = JSON.parse(packageJsonContent);
            logger_1.log.info(`Extracted package name [${packageJson.name}]`);
            return packageJson;
        }
        catch (error) {
            if (returnUndefinedOnError) {
                logger_1.log.warn(`Failed to read package.json at [${packageJsonPath}] with error [${String(error)}], returning undefined.`);
                return undefined;
            }
            throw new Error(`Failed to read package.json at [${packageJsonPath}] with an unknown error.`);
        }
    }
};
exports.PackageJson = PackageJson;
exports.PackageJson = PackageJson = PackageJson_1 = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log)
], PackageJson);
exports.formatPackageName = PackageJson.formatPackageName, exports.getPackageJson = PackageJson.getPackageJson, exports.loadPackageJson = PackageJson.loadPackageJson;
//# sourceMappingURL=package-json.js.map